import img0 from '../assets/img/portfolio/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA.jpg';
import img1 from '../assets/img/portfolio/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA 1.jpg';
import img2 from '../assets/img/portfolio/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA 2.jpg';
/* import img3 from '../assets/img/portfolio/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA 3.jpg';
import img4 from '../assets/img/portfolio/ALEXANDRA LUIS ROJO - TRABAJO DE GRADO DISEÑO DE MODA.jpg';
import img5 from '../assets/img/portfolio/ALEXANDRA LUIS ROJO - TRABAJO DE GRADO DISEÑO DE MODA1.jpg';
import img6 from '../assets/img/portfolio/DAYANA JANSEN - TRABAJO DE GRADO DISEÑO DE MODA.jpg';
import img7 from '../assets/img/portfolio/DAYANA JANSEN - TRABAJO DE GRADO DISEÑO DE MODA2.jpg';
import img8 from '../assets/img/portfolio/FRANCIS SANCHEZ - TRABAJO DE GRADO DISEÑO DE MODA1.jpg';
import img9 from '../assets/img/portfolio/FRANCIS SANCHEZ - TRABAJO DE GRADO DISEÑO DE MODA2.jpg';
import img10 from '../assets/img/portfolio/ISABELLA ZERPA - 2 TRABAJO DE GRADO DISEÑO DE MODA1.jpg';
import img11 from '../assets/img/portfolio/ISABELLA ZERPA - TRABAJO DE GRADO DISEÑO DE MODA.jpg';
import img12 from '../assets/img/portfolio/ISABELLA ZERPA - TRABAJO DE GRADO DISEÑO DE MODA2.jpg';
import img13 from '../assets/img/portfolio/JHOANA PADILLA - TRABAJO DE GRADO DISEÑO DE MODA.jpg';
import img14 from '../assets/img/portfolio/JHOANA PADILLA - TRABAJO DE GRADO DISEÑO DE MODA1.jpg';
import img15 from '../assets/img/portfolio/KRISMAR MENDOZA - TRABAJO DE GRADO DISEÑO DE MODA.jpg';
import img16 from '../assets/img/portfolio/KRISMAR MENDOZA - TRABAJO DE GRADO DISEÑO DE MODA1.jpg';
import img17 from '../assets/img/portfolio/WILTHMAN BONILLA - TRABAJO DE GRADO DISEÑO DE MODA2.jpg';
import img18 from '../assets/img/portfolio/WILTHMAN BONILLA - TRABAJO DE GRADO DISEÑO DE MODA3.jpg';
import img19 from '../assets/img/portfolio/WILTHMAN BONILLA - TRABAJO DE GRADO DISEÑO DE MODA4.jpg';
import img20 from '../assets/img/portfolio/YURAIMA FERRANTE - TRABAJO DE GRADO DISEÑO DE MODA.jpg';
import img21 from '../assets/img/portfolio/YURAIMA FERRANTE - TRABAJO DE GRADO DISEÑO DE MODA1.jpg'; */


const CarouselItems = [
    {
        id: 1,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ALEXANDER MATERÁN",
        img: img0
    },
    {
        id: 2,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ALEXANDER MATERÁN",
        img: img1
    },
    {
        id: 3,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ALEXANDER MATERÁN",
        img: img2
    },
    /* {
        id: 4,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ALEXANDER MATERÁN",
        img: img3
    },
    {
        id: 5,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ALEXANDRA LUIS ROJO",
        img: img4
    },
    {
        id: 6,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ALEXANDRA LUIS ROJO",
        img: img5
    },
    {
        id: 7,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "DAYANA JANSEN",
        img: img6
    },
    {
        id: 8,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "DAYANA JANSEN",
        img: img7
    },
    {
        id: 9,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "FRANCIS SANCHEZ",
        img: img8
    },
    {
        id: 10,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "FRANCIS SANCHEZ",
        img: img9
    },
    {
        id: 11,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ISABELLA ZERPA",
        img: img10
    },
    {
        id: 12,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ISABELLA ZERPA",
        img: img11
    },
    {
        id: 13,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "ISABELLA ZERPA",
        img: img12
    },
    {
        id: 14,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "JHOANA PADILLA",
        img: img13
    },
    {
        id: 15,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "JHOANA PADILLA",
        img: img14
    },
    {
        id: 16,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "KRISMAR MENDOZA",
        img: img15
    },
    {
        id: 17,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "KRISMAR MENDOZA",
        img: img16
    },
    {
        id: 18,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "WILTHMAN BONILLA",
        img: img17
    },
    {
        id: 19,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "WILTHMAN BONILLA",
        img: img18
    },
    {
        id: 20,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "WILTHMAN BONILLA",
        img: img19
    },
    {
        id: 21,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "YURAIMA FERRANTE",
        img: img20
    },
    {
        id: 22,
        titulo: "PORTAFOLIO DE ESTUDIANTES",
        tipo: "TRABAJO DE GRADO DISEÑO DE MODA",
        estudiante: "YURAIMA FERRANTE",
        img: img21
    } */
];

export default CarouselItems;


// WEBPACK FOOTER //
// ./src/shared/CarouselItems.jsx